<template>
  <div class="xbb">
    <div
      v-if="dialog.visible"
      class="flex items-center fullscreen xbb_dialog">
      <bonus-dialog-ad
        :adPic="bonusData.Ad && bonusData.Ad.AdPic"
        :adUrl="bonusData.Ad && bonusData.Ad.AdUrl"
        @close-dialog="closeDialog"/>
    </div>
  </div>
</template>

<script>
// https://github.com/pladaria/reconnecting-websocket#readme
import ReconnectingWebSocket from 'reconnecting-websocket'

import { mapState } from 'vuex'
import BonusDialogAd from './components/BonusDialogAd'
import { isIOS } from '@/utils/index.js'

export default {
  name: 'OnlyAd',
  components: {
    BonusDialogAd
  },
  props: {
    player: {
      type: Object,
      default: null
    },
    playingEvent: {
      type: Function,
      default: () => {
        return () => { }
      }
    },
    pauseEvent: {
      type: Function,
      default: () => {
        return () => { }
      }
    },
    isDestroy: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // WebSocket
      ws: null,
      socketId: null,
      // Dialog
      dialog: {
        visible: false
      },
      // WebSocket 回傳資料
      bonusData: {
        Ad: {
          AdPic: null,
          AdUrl: null
        }
      }
    }
  },
  computed: {
    ...mapState({
      xbbBonus: state => state.xbbBonus
    })
  },
  mounted () {
    this.init()
    this.hijackPlaying()
    this.hijackPasue()
  },
  beforeDestroy () {
    this.sendWebSocket('ADSTOP')
    this.ws.close()
  },
  methods: {
    init () {
      const { domain, userid, cid, wsUrl } = this.xbbBonus
      this.ws = new ReconnectingWebSocket(`${wsUrl}?domain=${domain}&userid=${userid}&cid=${cid}`, [], {
        maxRetries: 10, // maximum number of retries
        maxReconnectionDelay: 3000,
        minReconnectionDelay: 3000
      })

      this.ws.onopen = (event) => {
        console.log('ws onopen')
      }

      this.ws.onclose = (event) => {
        console.log('ws close reason:', event.reason)
        if (event.reason === 'NO ACTIVITY') return this.closeWs()
      }

      this.ws.onmessage = (event) => {
        const data = JSON.parse(event.data)
        this.socketId = data.SocketId

        switch (data.Status) {
          case 'OPEN':
            this.intoPageAd()
            if (!this.player.paused()) {
              this.sendWebSocket('ADSTART')
            }
            break
          case 'AD':
            this.bonusData = data
            if (this.player.isFullscreen() && isIOS) this.player.exitFullscreen()
            this.player.pause()
            this.dialog.visible = true
            break
          case 'NOACTIVE':
            this.closeWs()
            break
        }
      }
    },
    closeDialog (type) {
      this.dialog.visible = false
    },
    sendWebSocket (type) {
      if (this.ws && this.socketId !== null) {
        this.ws.send(JSON.stringify({
          SocketId: this.socketId,
          Type: type,
          SendTime: new Date().toISOString()
        }))
      }
    },
    intoPageAd () {
      this.sendWebSocket('AD')
    },
    // 劫持playing函數, 使事件能夠解耦
    hijackPlaying () {
      const parentPlaying = this.playingEvent
      this.$emit('update:playing-event', () => {
        parentPlaying()
        this.sendWebSocket('ADSTART')
      })
    },
    hijackPasue () {
      const parentPause = this.pauseEvent
      this.$emit('update:pause-event', () => {
        parentPause()
        this.sendWebSocket('ADSTOP')
      })
    },
    closeWs () {
      this.$emit('update:isDestroy', true)
    }
  }
}
</script>

<style scoped>

.xbb_dialog {
  padding: 24px;
  background: rgba(0, 0, 0, 0.4);
}

.fullscreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 6000;
  max-width: 100vw;
  max-height: 100vh;
  padding-top: 75px;
  overflow: auto;
  border-radius: 0 !important;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.items-center {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/xbb/OnlyAd.vue